module.exports = __webpack_public_path__ + "static/media/InProcessIcon.37221249.svg";